<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <div style="display: flex; flex-wrap: wrap">
        <div style="flex-shrink: 1; white-space: nowrap">
          <h1>Search Result</h1>
        </div>
      </div>

      <p-table
        #dataTable
        selectionMode="single"
        *ngIf="isLoaded; else loading"
        [value]="page.items"
        [responsive]="true"
        resizableColumns="true"
        [(selection)]="selectedJob"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
        [paginator]="true"
        styleClass="data-table-compact"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="from.primaryAddress">From</th>
            <th pSortableColumn="to.primaryAddress">To</th>
            <th pSortableColumn="jobNumber">Job Number</th>
            <th>Job Status</th>
            <th pSortableColumn="orderNumber">Order No.</th>
            <th pSortableColumn="vehicleRegNumber">Reg No.</th>
            <th pSortableColumn="latestPickupDate">Pickup Time</th>
            <th pSortableColumn="latestDropOffDate">Dropoff Time</th>
            <th pSortableColumn="JobCompletedOrCancelledDate">Completed Date</th>
            <th pSortableColumn="customerName">Customer</th>
            <th pSortableColumn="supplierName">Supplier</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr (dblclick)="showDetails(item)" [pSelectableRow]="item">
            <td>{{ item.from.primaryAddress }}</td>
            <td>{{ item.to.primaryAddress }}</td>
            <td>{{ item.jobNumber }}</td>
            <td>
              <span>{{ getStatus(item) }}</span>
            </td>
            <td>{{ item.orderNumber }}</td>
            <td>{{ vehicleCountPostfix(item, item.vehicleRegNumber) }}</td>
            <td>{{ item.latestPickupDate | datex : 'ddd DD MMM YYYY HH:mm' }}</td>
            <td>{{ item.latestDropOffDate | datex : 'ddd DD MMM YYYY HH:mm' }}</td>
            <td>{{ item.jobCompletedOrCancelledDate | datex : 'ddd DD MMM YYYY HH:mm' }}</td>
            <td>{{ item.customerName }}</td>
            <td>{{ item.supplierName }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED ---
      <p-dataTabl #dataTable selectionMode="single"
                   *ngIf="isLoaded; else loading"
                   [value]="page.items"
                   [responsive]="true"
                   resizableColumns="true"
                   (onRowDblclick)="showDetails(selectedJob)"
                   [(selection)]="selectedJob"
                   styleClass="data-table-compact">
        <p-column field="from.primaryAddress" header="From" [sortable]="tru" [editable]="false"
                  [style]="{'width': '10%'}"></p-column>
        <p-column field="to.primaryAddress" header="To" [sortable]="tru" [editable]="false"
                  [style]="{'width': '10%'}"></p-column>
        <p-column field="jobNumber" header="Job Number" [sortable]="tru" [editable]="false"
                  [style]="{'width': '8.5em'}"></p-column>
        <p-column header="Job Status" [sortable]="false" [editable]="false" [style]="{'width': '8em'}">
          <ng-template let-col let-item="rowData" pTemplate="body">
            <span>{{ getStatus(item) }}</span>
          </ng-template>
        </p-column>
        <p-column field="orderNumber" header="Order No." [sortable]="tru" [editable]="false"
                  [style]="{'width': '8.5em'}"></p-column>
        <p-column field="vehicleRegNumber" header="Reg. No." [sortable]="tru" [editable]="false"
                  [style]="{'width': '7em'}">
          <ng-template let-item="rowData" pTemplate="body">
            {{vehicleCountPostfix(item, item.vehicleRegNumber)}}
          </ng-template>
        </p-column>
        <p-column field="latestPickupDate" header="Pick up time" [sortable]="tru" [editable]="false"
                  [style]="{'width': '12.5em'}">
          <ng-template pTemplate="body" let-item="rowData">
            {{ item.latestPickupDate | datex:'ddd DD MMM YYYY HH:mm' }}
          </ng-template>
        </p-column>
        <p-column field="latestDropOffDate" header="Drop off time" [sortable]="tru" [editable]="false"
                  [style]="{'width': '12.5em'}">
          <ng-template pTemplate="body" let-item="rowData">
            {{ item.latestDropOffDate | datex:'ddd DD MMM YYYY HH:mm' }}
          </ng-template>
        </p-column>
        <p-column field="customerName" header="Customer" [sortable]="tru" [editable]="false"
                  [style]="{'width': '8%'}">
          <ng-template let-item="rowData" pTemplate="body">
            {{item.customerName}}
          </ng-template>
        </p-column>
        <p-column field="supplierName" header="Supplier" [sortable]="tru" [editable]="false"
                  [style]="{'width': '8%'}">
          <ng-template let-item="rowData" pTemplate="body">
            {{item.supplierName}}
          </ng-template>
        </p-column>
      </p-dataTable>
      --->

      <ng-template #loading>Loading...</ng-template>
      <div class="footerPanel ui-grid-row">
        <button
          [label]="organisationTypeId == 2 ? 'Order Details' : 'Job Details'"
          [disabled]="!selectedJob"
          class="btn-to-right"
          (click)="showDetails(selectedJob)"
          pButton
        ></button>
      </div>
    </div>
  </div>
</div>
